import { toast } from "react-toastify";
import { revertAllactionTypeData } from "../apis/RevertAllActionType";

export const handleRevertAllFunc = async (actionData, navigate, location, setRevertAllModal) => {
  try {
    let newState = {
      name: location.state.name || "",
    };
    setRevertAllModal(false);

    const { message } = await revertAllactionTypeData(actionData);

    toast.success(message);
    navigate("/Setting/synchronize", { state: newState });
  } catch (error) {
    console.log("error", error);
  }
};
